document.addEventListener("DOMContentLoaded", () => {
  if (!window.announcementSwiper) {
    const announcementSwiper = new Swiper(".announcement-swiper", {
      direction: "horizontal",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      loop: true,
    });
    window.announcementSwiper = announcementSwiper;
  }
});
